import {styled} from "@mui/material/styles";
import Slider from "@mui/material/Slider";
// import {isMobile} from 'react-device-detect';
import st from "@/styles/Ui.module.scss"
import CommonClass from "@/utils/common.ts";

interface Props {
    max:number
    value:number
    danger?: boolean
    valuetext?:string
    secondary?:boolean
    denyValueLabel?:boolean
    railColor?:string
    height?: number,
    thumbInvisible?:boolean
    to_fixed?:boolean
    no_value_display?:boolean
}

const StaticRangeSlider = (props: Props)=> {
    
    const {
        max,
        danger,
        value,
        // valuetext,
        secondary,
        // denyValueLabel,
        railColor,
        height,
        thumbInvisible,
        to_fixed,
        no_value_display
    } = props
    
    const val = to_fixed ? CommonClass.formatMoneyAmount(value) : value.toFixed(0)
    const mx = to_fixed ? CommonClass.formatMoneyAmount(max) : max.toFixed(0)
    
    let local_sizes = height ? height : 12
    
    const getColor = ():string => {
        if (danger) {
            return "#AC3636"
        }
        
        if(secondary) {
            return "#EA7C15"
        }
        
        return "#007814"
    }
    
    return (
        <div className={st.range_slider_cont}>
            {/*{isMobile ? (*/}
            {!no_value_display ? (
                <span style={{color: getColor()}} className={st.badge}>
                    {`${val}/${mx}`}
                </span>
            ) : null}
            {/*) : null}*/}
            
            <LocalSlider
                disabled={false}
                marks={false}
                max={max}
                min={0}
                sx={{
                    color: getColor(),
                    height: local_sizes,
                    // pointerEvents: isMobile ? "none" : "unset",
                    pointerEvents: "none",

                    '& .MuiSlider-valueLabel': {
                        backgroundColor: getColor(),
                        boxShadow:"0px 4px 12px 0px rgba(0, 0, 0, 0.2), 0px 4px 20px 0px rgba(0, 0, 0, 0.3)"
                    },
                    
                    '& .MuiSlider-rail': {
                        backgroundColor: railColor ? railColor : '#e8e8e8',
                    },
                    
                    '& .MuiSlider-thumb': {
                        height: local_sizes,
                        width: local_sizes,
                        display: thumbInvisible ? "none" : ""
                    }
                }}
                valueLabelFormat={(value) => `${to_fixed ? CommonClass.formatMoneyAmount(value) : value.toFixed(0)}/${mx}`}
                value={value}
                // value={0}
                valueLabelDisplay={"off"}
                className={"calculator_range_slide"}
            />
        </div>

    )
}

const LocalSlider = styled(Slider)({
    
    '& .MuiSlider-track': {
        border: 'none',
        borderRadius: "100px",
        
    },
    '& .MuiSlider-thumb': {
        height: "8px",
        width: "8px",
        transform: "translate(-8px, 0)",
        border: 'none',
        background: "transparent",
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&::before': {
            display: 'none',
        },
    },
    
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 12,
        fontWeight: "700",
        background: 'unset',
        width: "auto",
        padding: "10px",
        height: "auto",
        borderRadius: '5px',
        // backgroundColor: '#007814',
    },
    '& .MuiSlider-rail': {
        opacity: 1,
        borderRadius: "100px",
        backgroundColor: '#e8e8e8',
    },
});


export default StaticRangeSlider